import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const AdjustServiceDuringQualityControlTaskMessage = ({
  article,
}: {
  article: ArticleWithRelations;
}) => {
  return (
    <>
      <BaseMessage
        title={
          <Trans id="article.task.adjust_service_during_quality_control.title">
            Adjust service and actions
          </Trans>
        }
        message={
          <Trans id="article.task.adjust_service_during_quality_control.message">
            Please adjust the item's service and actions, then confirm in order to come back to the
            quality control.
          </Trans>
        }
        article={article}
      />
    </>
  );
};
